import React, { useEffect, useMemo, useState } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import {
  useAddPackingEveningEmployeeMutation,
  useAddPackingMorningEmployeeMutation,
  useUpdatePackingEveningEmployeeMutation,
  useUpdatePackingMorningEmployeeMutation,
} from "./packingwashingApi";
import { useGetLotNumberQuery } from "../packing/packingApi";
import { getCurrentTime } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";

const WashingModal = ({ show, setShow, employee, mode }) => {
  const [addMorningEmployee] = useAddPackingMorningEmployeeMutation();
  const [addEveningEmployee] = useAddPackingEveningEmployeeMutation();
  const [editMorningEmployee] = useUpdatePackingMorningEmployeeMutation();
  const [editEveningEmployee] = useUpdatePackingEveningEmployeeMutation();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const { data: lotNumber } = useGetLotNumberQuery({ date: currentDate });
  const { _t } = useTranslator();

  const initialFormData = useMemo(
    () => ({
      date: getCurrentTime(),
      emp_total: "",
      orange_cases: "",
      red_cases: "",
      yellow_cases: "",
      carts: "",
      treys: "",
      knifes: "",
      bowls: "",
      lot_number_id: lotNumber?.data,
    }),
    [lotNumber?.data]
  );
  useEffect(() => {
    if (lotNumber?.data) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        lot_number_id: lotNumber.data,
      }));
    }
  }, [lotNumber]);

  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if ((mode === "editMorning" || mode === "editEvening") && employee) {
      const mappedData = { ...employee };

      if (mappedData.lot_number) {
        mappedData.lot_number_id = mappedData.lot_number;
        delete mappedData.lot_number;
      }

      setFormData(mappedData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, employee, show, initialFormData]);

  const mutationMap = {
    addMorning: addMorningEmployee,
    addEvening: addEveningEmployee,
    editMorning: editMorningEmployee,
    editEvening: editEveningEmployee,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const selectedMutation = mutationMap[mode];
      if (!selectedMutation) throw new Error("Unknown mode");

      const payload = mode.startsWith("edit")
        ? { id: employee?.id, requestBody: formData }
        : formData;

      await selectedMutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const renderFormFields = () => {
    if (mode === "addMorning" || mode === "editMorning") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employee", "Total Employee")}              
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("orange_cases", "Orange Cases")}              
              type="number"
              name="orange_cases"
              value={formData.orange_cases}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("red_cases", "Red Cases")}              
              type="number"
              name="red_cases"
              value={formData.red_cases}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("yellow_cases", "Yellow Cases")}              
              type="number"
              name="yellow_cases"
              value={formData.yellow_cases}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        </>
      );
    } else if (mode === "addEvening" || mode === "editEvening") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employee", "Total Employee")}              
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("carts", "Carts")}              
              type="number"
              name="carts"
              value={formData.carts}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("treys", "Trey")}              
              type="number"
              name="treys"
              value={formData.treys}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("knifes", "Knifes")}
              type="number"
              name="knifes"
              value={formData.knifes}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("bowls", "Bowls")}
              type="number"
              name="bowls"
              value={formData.bowls}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        </>
      );
    }
  };
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "addMorning" || mode === "editMorning"
          ? _t("morning_shift", "Morning Shift")
          : _t("evening_shift", "Evening Shift")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            isLoading={"isCreating" || "isUpdating"}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default WashingModal;
